import { createContext, useContext, useState, useCallback } from 'react';

const LateralMenuContext = createContext();

export function LateralMenuProvider({ children }) {
  const [userPreference, setUserPreference] = useState(
    localStorage.getItem('lateralMenu')
  );
  const [underlineMenu, setUnderlineMenu] = useState(
    localStorage.getItem('underlineMenu')
  );
  const [adminConfig, setAdminConfig] = useState(null);

  // Persistence for expansion state (0, 1, 2)
  const isPinned = userPreference !== null ? userPreference === 'true' : adminConfig === 1;
  const [expand, setExpand] = useState(isPinned ? 1 : 0);
  const [mobileOnly, setMobileOnly] = useState(false);
  const [previousExpand, setPreviousExpand] = useState(null);

  const setLateralMenu = useCallback((value) => {
    const stringValue = String(value);
    setUserPreference(stringValue);
    localStorage.setItem('lateralMenu', stringValue);

    // Auto-expand if pinning, or follow common logic
    if (value === true) setExpand(1);
  }, []);

  const setUnderlineMenuPreference = useCallback((value) => {
    const stringValue = String(value);
    setUnderlineMenu(stringValue);
    localStorage.setItem('underlineMenu', stringValue);
  }, []);

  return (
    <LateralMenuContext.Provider value={{
      lateralMenu: isPinned,
      setLateralMenu,
      underlineMenu: underlineMenu === 'true',
      setUnderlineMenuPreference,
      adminConfig,
      expand,
      setExpand,
      mobileOnly,
      setMobileOnly,
      previousExpand,
      setPreviousExpand
    }}>
      {children}
    </LateralMenuContext.Provider>
  );
}

export function useLateralMenu() {
  return useContext(LateralMenuContext);
}